export const hasWhiteSpace = (str: string): boolean => {
	return str.search(/\s/) >= 0;
};
